/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orders: NonNullable<unknown>, qty: NonNullable<unknown>, unit: NonNullable<unknown> }} Lot_Debt_Fill_Still_OwingInputs */

const vi_lot_debt_fill_still_owing = /** @type {(inputs: Lot_Debt_Fill_Still_OwingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.orders} đơn vẫn nợ ${i?.qty} ${i?.unit} — chờ lô sau bù tiếp.`)
};

/**

* @param {Lot_Debt_Fill_Still_OwingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_debt_fill_still_owing = /** @type {((inputs: Lot_Debt_Fill_Still_OwingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Debt_Fill_Still_OwingInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_debt_fill_still_owing(inputs)
});